import { Box } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import AppLoading from './appLoading';

interface AppLoaderBlurProps {
  isLoading: boolean;
}

const styles = {
  topBox: {
    position: 'relative',
  },
  overlayBox: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    zIndex: 100,
  },
  loaderBox: {
    mt: -5,
    width: '100%',
  },
  blurredChildBox: {
    filter: 'blur(4px)',
  },
};

export function AppLoaderBlur({
  children,
  isLoading,
}: PropsWithChildren<AppLoaderBlurProps>): JSX.Element {
  if (isLoading) {
    return (
      <Box sx={styles.topBox}>
        <Box sx={styles.overlayBox}>
          <Box sx={styles.loaderBox}>
            <AppLoading />
          </Box>
        </Box>

        <Box sx={styles.blurredChildBox}>{children}</Box>
      </Box>
    );
  } else {
    return <>{children}</>;
  }
}
